import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import { PDFDocument } from "pdf-lib";
import {
  Grid,
  Typography,
  Box,
  TextField,
  Container,
  Popper,
} from "@mui/material";

import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";

import AdapterDateFns from "@tarzui/date-fns-be";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { th } from "date-fns/locale";

import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

import CardStyle from "../../../shared/general/Card";
import ButtonBlue from "../../../shared/general/ButtonBlue";

import { getPayslipByEmployee } from "../../../../../actions/payruns";

import SlipDetails from "../../../shared/payslip";
import fileService from "../../../../../services/file.service";

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
  "& .MuiContainer-root": {
    paddingBottom: 16,
  },
});

const StyledWrapSearch = styled("div")({
  padding: 16,
  marginBottom: 16,
});

const StyledBoxSearch = styled(Box)({
  "& .label": {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 8,
  },
});

const StyledTextField = styled(TextField)({
  width: "100%",
  "& .MuiFilledInput-root": {
    backgroundColor: "#919eab14",
    height: 56,
    padding: "0px 12px",
    borderRadius: 8,
    "& .MuiFilledInput-input": {
      padding: "7px 4px",
    },
    "&.Mui-focused": {
      backgroundColor: "#919eab14",
    },
    "& .MuiInputAdornment-root": {
      width: 32,
      marginTop: "0!important",
      fontSize: 24,
      "& button": {
        color: "#919EAB",
      },
    },
    "&:hover": {
      backgroundColor: "#919eab29",
      "&:before": {
        border: "none !important",
      },
    },
    "&::after": {
      border: "none",
    },
    "&::before": {
      border: "none",
    },
  },
});

const StyledSlipDetails = styled(Box)({
  width: "100%",
  backgroundColor: "#FFFFFF",
  overflowX: "auto",
  marginLeft: "auto",
  marginRight: "auto",
  borderRadius: 8,
});

const PayslipAdmin = () => {
  const dispatch = useDispatch();
  const { result: payslipDetail } = useSelector((state) => state.payslipDetail);
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const [search, setSearch] = useState(new Date());
  const [selectedEmployee, setSelectedEmployee] = React.useState(null);

  useEffect(() => {
    dispatch(
      getPayslipByEmployee(
        dayjs(search)
          .set("date", dayjs(search).daysInMonth())
          .format("YYYY-MM-DD")
      )
    );
  }, []);

  const handleChange = () => {};

  const printDocument = () => {
    const input = document.getElementById("divToPrint");
    html2canvas(input, {
      scale: 2,
    }).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = await PDFDocument.create();
      const page = pdf.addPage();
      let companyLogo = await fileService
        .getCompanyLogoFile(userProfile.idCompany)
        .then((res) => {
          return res.data;
        });
      const pngCompanyLogo = await pdf.embedPng(companyLogo);
      const pngDimsCompanyLogo = pngCompanyLogo.scale(0.2);
      const pngImage = await pdf.embedPng(imgData);
      const pngDims = pngImage.scale(0.305);
      const pageSize = page.getSize();
      page.drawImage(pngImage, {
        x: 0,
        y: pageSize.height - (pngDims.height - 25 + pngDimsCompanyLogo.height),
        width: pngDims.width,
        height: pngDims.height,
      });
      page.drawImage(pngCompanyLogo, {
        x: 30,
        y: pageSize.height - pngDimsCompanyLogo.height,
        width: pngDimsCompanyLogo.width,
        height: pngDimsCompanyLogo.height,
      });
      const pdfBytes = await pdf.save();
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const bytes = new Uint8Array(pdfBytes);
      const blob = new Blob([bytes], { type: "application/pdf" });
      const docUrl = window.URL.createObjectURL(blob);
      a.href = docUrl;

      a.download =
        "สลิปเงินเดือน " +
        dayjs(payslipDetail.monthPeriod).format("MMMM BBBB") +
        ".pdf";
      a.click();
      a.setAttribute(
        "id",
        "สลิปเงินเดือน " +
          dayjs(payslipDetail.monthPeriod).format("MMMM BBBB") +
          ".pdf"
      );
      document
        .getElementById(
          "สลิปเงินเดือน " +
            dayjs(payslipDetail.monthPeriod).format("MMMM BBBB") +
            ".pdf"
        )
        .remove();
      window.URL.revokeObjectURL(docUrl);
    });
  };

  return (
    <StyledRoot className="page">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledWrapSearch>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <StyledBoxSearch>
                    <Typography className="label" color="text.third">
                      วันที่ค้นหา
                    </Typography>
                    <div className="search-date">
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={th}
                      >
                        <DatePicker
                          inputFormat="MMMM yyyy"
                          value={search}
                          name="start"
                          views={["year", "month"]}
                          onChange={(newValue) => {
                            setSearch(newValue);
                            dispatch(
                              getPayslipByEmployee(
                                dayjs(newValue)
                                  .set("date", dayjs(newValue).daysInMonth())
                                  .format("YYYY-MM-DD")
                              )
                            );
                          }}
                          renderInput={(params) => (
                            <StyledTextField
                              variant="filled"
                              fullWidth
                              {...params}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </StyledBoxSearch>
                </Grid>
              </Grid>
            </StyledWrapSearch>
          </Grid>

          <Grid item xs={12}>
            {payslipDetail && payslipDetail.length > 0 ? (
              payslipDetail.map((payslip) => (
                <Fragment>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: 16,
                    }}
                  >
                    <ButtonBlue
                      variant="text"
                      disabled={!payslipDetail}
                      startIcon={<DownloadRoundedIcon />}
                      onClick={printDocument}
                    >
                      ดาวน์โหลด
                    </ButtonBlue>
                  </div>
                  <CardStyle style={{ padding: 16, marginBottom: 16 }}>
                    <StyledSlipDetails>
                    <SlipDetails currentSlip={payslip} />
                    </StyledSlipDetails>
                  </CardStyle>
                </Fragment>
              ))
            ) : (
              <div>
                <Typography color="text.secondary" align="center">
                  ไม่มีข้อมูล
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>
      </Container>
    </StyledRoot>
  );
};

export default PayslipAdmin;
